<template>
  <div class="host" v-if="hasPermission('read')">
    <div v-if="withDialog" class="vm-data-table-header">
      <h2>{{ title }}</h2>
      <Button v-if="hasPermission('create')" vm-raised-button color="primary" @click="openCreateDialog()">
        Создать
      </Button>
    </div>
    <Card vm-stroked class="vm-datatable-card">
      <div v-if="withSearch" class="vm-card-header">
        <b-form-input
          type="text"
          v-model="search"
          placeholder="Поиск..."
        ></b-form-input>
      </div>
      <div class="vm-card-content">
        <div v-if="loading" class="vm-card-overlay">
          <ProgressBar />
        </div>
        <VMTable v-if="items.length">
          <template #header>
            <tr>
              <th v-for="field in fields" :key="field.name">
                {{ field.label }}
              </th>
              <th v-if="hasPermission('delete') && hasPermission('update')" class="action-cell">Действия</th>
            </tr>
          </template>
          <template #body>
            <tr v-for="item in items" :key="item.id">
              <td v-for="field in fields" :key="field.name">
                {{ item[field.name] }}
              </td>
              <td style="min-width:90px" v-if="hasPermission('delete') && hasPermission('update')">
                <button v-if="hasPermission('update') && withEditOrRoute" class="vm-icon-button" @click="openEditDialog(item.id)">
                  <i class="material-icons">edit</i>
                </button>
                <button v-if="hasPermission('update') && !withEditOrRoute" class="vm-icon-button" @click="$emit('route-to', item)">
                  <i class="material-icons">edit</i>
                </button>
                <button v-if="hasPermission('delete')" class="vm-icon-button" @click="openRemoveDialog(item)">
                  <i class="material-icons">delete</i>
                </button>
              </td>
            </tr>
          </template>
        </VMTable>
        <div v-else class="vm-empty-table">Список пуст</div>
      </div>
      <div v-if="items.length" class="vm-card-footer">
        <Paginator v-model="pageIndex" :length="length" :pageSize="pageSize" />
      </div>
    </Card>
    <Dialog class="vm-edit-dialog" v-model="showEditDialog">
      <h4>{{ id ? 'Редактирование' : 'Создание' }}</h4>
      <DinamicForm
        class="datatable-form"
        @submit="submit"
        @cancel="showEditDialog = false"
        @select="addForm"
        :scheme="scheme"
        :options="options"
        :data="form"
        :submitLabel="id ? 'Сохранить' : 'Создать'"
      />
    </Dialog>
    <Dialog class="vm-remove-dialog" v-model="showRemoveDialog">
      <div class="vm-remove-dialog">
        <div class="vm-remove-dialog-header">
          Внимание данная запись будет удалена!
        </div>
        <div class="vm-remove-dialog-content" v-if="selectedItem">
          <div class="vm-item" v-for="field in fields" :key="field.name">
            <div class="vm-item-label">{{ field.label }}</div>
            <div class="vm-item-value">{{ selectedItem[field.name] }}</div>
          </div>
        </div>
        <div class="vm-remove-dialog-footer">
          <Button class="vm-cancel-button" @click="showRemoveDialog = false">
            Отмена
          </Button>
          <Button @click="remove()" color="danger">Удалить</Button>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import VMTable from './Table';
import Dialog from './Dialog';
import Card from './Card';
import Paginator from './Paginator';
import ProgressBar from './ProgressBar';
import DinamicForm from './dynamic-form/Index';
import Button from './Button';
import toastr from 'toastr';

export default {
  components: {
    VMTable,
    Dialog,
    Card,
    Paginator,
    ProgressBar,
    DinamicForm,
    Button
  },
  props: {
    title: String,
    permissions: {
      type: Array,
      default: () => []
    }, /* [ 'create', 'read', 'update', 'delete' ] */ 
    service: Object,
    fields: Array,
    scheme: Object,
    options: Object,
    withDialog: {
      type: Boolean,
      default: true
    },
    withSearch: {
      type: Boolean,
      default: true
    },
    withEditOrRoute: {
      type: Boolean,
      default: true
    },
    searchOutside: String,
    pageSize: {
      type: Number,
      default: 10
    }
  },
  data: () => ({
    loading: false,
    search: null,
    editMode: false,
    showRemoveDialog: false,
    showEditDialog: false,
    pageIndex: 1,
    length: 0,
    form: null,
    id: null,
    selectedItem: null,
    items: []
  }),
  watch: {
    async pageIndex(pageIndex) {
      await this.loadTable(this.pageSize, pageIndex, this.search);
    },
    search: debounce(async function(search) {
      await this.loadTable(this.pageSize, 1, search);
    }, 200),
    searchOutside(evt) {
      this.search = evt;
    }
  },
  async created() {
    await this.reflashTable();
  },
  methods: {
    addForm(evt) {
      if (this.scheme.controls.workemail) {
        this.form.lastName.value = evt.obj.lastName;
        this.form.firstName.value = evt.obj.firstName;
        this.form.middleName.value = evt.obj.middleName;
        this.form.workemail.value = evt.obj.email;
        this.form.phone.value = evt.obj.phone;
        this.form.workphone.value = evt.obj.phone;
      }
    },
    hasPermission(permission) {
      if (!this.permissions.length) {
        return true;
      }
      return this.permissions.indexOf(permission) > -1;
    },
    async submit() {
      const data = this.getData(this.scheme, this.form); console.log(data);
      if (this.id === null) {
        await this.service.create(data).then(res => {
          toastr.success('Успешно добавлен');
          this.showEditDialog = false;
        }).catch(error => {
          toastr.error('Не все поля заполнены');
        });
      } else {
        await this.service.update(this.id, data).then(res => {
          toastr.success('Успешно');
        }).catch(error => {
          toastr.error(error ? error[0] : 'Ошибка сохранения, убедитесь в правильности данных');
        });
        this.showEditDialog = false;
      }
      await this.reflashTable();
    },
    openCreateDialog() {
      this.id = null;
      this.form = this.generateDataByScheme(this.scheme);
      this.showEditDialog = true;
    },
    async openEditDialog(id) {
      await this.loadForm(id);
      this.showEditDialog = true;
    },
    openRemoveDialog(item) {
      this.selectedItem = item;
      this.id = item.id;
      this.showRemoveDialog = true;
    },
    remove() {
      this.service.remove(this.id).then(res => {
        toastr.info('Запись удалена');
      }).catch(error => {
        toastr.error(error);
      }).finally(f => {
        this.reflashTable();
      });
      this.showRemoveDialog = false;
    },
    createForm(scheme, options, data) {
      return this.buildForm(scheme, options, data);
    },
    generateDataByScheme(scheme) {
      if (Array.isArray(scheme.controls)) {
        return scheme.controls.map(control => {
          return this.generateDataByScheme(control);
        });
      } else if (typeof scheme.controls !== 'undefined') {
        return Object.entries(scheme.controls).reduce(
          (acc, [name, control]) => {
            acc[name] = this.generateDataByScheme(control);
            return acc;
          },
          {}
        );
      }
      return { value: null };
    },
    getData(scheme, form) {
      if (Array.isArray(scheme.controls)) {
        // form array
        // @todo array convertor
      } else if (typeof scheme.controls !== 'undefined') {
        // form group
        return Object.entries(scheme.controls).reduce((acc, [key, control]) => {
          acc[key] = this.getData(control, form[key]);
          return acc;
        }, {});
      }
      if (scheme.type === 'autocomplete') {
        if (form.value) {
          return form.value.value;
        } else {
        toastr.error('Введите данные: "' + scheme.label + '"');
      }
      }
      return form.value;
    },
    buildForm(scheme, options, data) {
      if (Array.isArray(scheme.controls)) {
        // form array
        // @todo array convertor
      } else if (typeof scheme.controls !== 'undefined') {
        // form group
        return Object.entries(scheme.controls).reduce((acc, [key, control]) => {
          acc[key] = this.buildForm(control, options, data[key]);
          return acc;
        }, {});
      }
      if (scheme.type === 'autocomplete') {
        const { getLabel } = options[scheme.optionName];
        return { value: getLabel(data) };
      }
      return { value: data };
    },
    async loadForm(id) {
      const data = await this.service.get(id);
      this.id = id;
      this.form = this.createForm(this.scheme, this.options, data);
    },
    async loadTable(pageSize, pageIndex, search) {
      this.loading = true;
      try {
        const { items, total } = await this.service.getAll(
          pageSize,
          pageIndex, // ??? pageSize * (pageIndex - 1),
          search
        );
        this.length = total;
        this.items = items.map(item => {
          return this.fields.reduce(
            (acc, curr) => {
              acc[curr.name] =
                typeof curr.value === 'undefined'
                  ? item[curr.name]
                  : curr.value(item);
              return acc;
            },
            { id: item.id, data: item.data ? item.data : null, avatar: item.avatar }
          );
        });
        console.log('this.items', this.items);
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
    async reflashTable() {
      await this.loadTable(this.pageSize, this.pageIndex, this.search);
      this.id = null;
    }
  }
};
</script>

<style scoped>
.host >>> form > .vm-form-group {
  border: 0;
}
.vm-card-content {
  position: relative;
}
.vm-card-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  background-color: rgba(255, 255, 255, 0.7);
}
.vm-data-table-header {
  display: flex;
  margin-bottom: 1rem;
  align-items: center;
}
.vm-data-table-header h2 {
  font-size: 24px;
  font-weight: 300;
  margin: 0;
}
.vm-data-table-header .host {
  margin-left: auto;
}
.vm-edit-dialog h4 {
  padding: 2rem;
  padding-bottom: 0;
  margin-bottom: 0;
  font-size: 18px;
}
.vm-edit-dialog >>> .vm-dialog {
  width: 100%;
  max-width: 700px;
}
.vm-remove-dialog >>> .vm-dialog {
  width: 100%;
  max-width: 450px;
}
.vm-icon-button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: 0;
  background-color: transparent;
  outline: none;
  background: transparent;
  border-radius: 50%;
  height: 24px;
  width: 24px;
  margin: 2px;
}
.vm-icon-button:focus {
  background-color: rgba(0, 0, 0, 0.05);
}
.vm-icon-button i {
  color: #757575;
  font-size: 16px;
}
.vm-card-header {
  border-radius: 4px 4px 0 0;
  padding: 1rem;
  background-color: rgba(0, 0, 0, 0.03);
}
.vm-card-footer {
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
  background-color: rgba(0, 0, 0, 0.03);
  border-radius: 0 0 4px 4px;
}
.vm-card-footer ul {
  margin: 0;
}
.vm-empty-table {
  color: #7a7a7a;
  padding: 0 24px;
  line-height: 56px;
}
.action-cell {
  width: 10px;
}
.vm-remove-dialog {
  padding: 12px;
}
.vm-remove-dialog-header {
  font-size: 18px;
  padding: 0 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #dfdfdf;
}
.vm-remove-dialog-content {
  padding: 12px;
}
.vm-remove-dialog-footer {
  display: flex;
  justify-content: flex-end;
  padding: 0 12px;
}
.vm-item {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.vm-item:last-child {
  margin-bottom: 0;
}
.vm-item-label {
  width: 33.333%;
  color: #747474;
  font-weight: 500;
}
.vm-item-value {
  width: 66.666%;
}
.vm-cancel-button {
  margin-right: 12px;
}
</style>
